import { connect } from 'react-redux';
import { getUserEmail, getUserName, getCustomText, isClientReady } from 'app/modules';

import InteractiveOnboarding from 'presentation/selfService/InteractiveOnboarding';

export const mapStateToProps = (state, props) => {
  return {
    customText: getCustomText(state),
    email: getUserEmail(state),
    isClientReady: isClientReady(state),
    isReadyForConfirmation: !!(isClientReady(state) && getUserName(state)),
    name: getUserName(state),
    updateScrollPosition: props.updateScrollPosition,
  };
};

export default connect(mapStateToProps)(InteractiveOnboarding);
